module.exports = __webpack_public_path__ + "static/media/feedback-icon.7bce35d0.svg";